import { getLocalization } from 'global/global';
import * as React from 'react';
import { Button, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { StateInterface } from 'Interfaces/StateInterface';
import { userRoles } from 'Interfaces/User';
import { VIEW } from '..';

interface Props {
  view: VIEW;
  setView: (view: VIEW) => void;
}

export default function Actions(props: Props) {
  const { roles } = useSelector((state: StateInterface) => state.clientPersist);
  return (
    <Container>
      <Button
        size="sm"
        active={props.view === 'EDITOR'}
        onClick={() => props.setView('EDITOR')}
        disabled={userRoles.VIEWER === roles}
      >
        {getLocalization('addDocument')}
      </Button>
      <Button
        size="sm"
        active={props.view === ''}
        className="ms-1"
        onClick={() => props.setView('')}
      >
        {getLocalization('activity')}
      </Button>
    </Container>
  );
}
